import { Button, ExternalLink, Note, Row, Section } from '../../components/ui';
import { projects } from '../../data/projects';
import { experience } from '../../data/experience';
import { profile } from '../../data/profile';
import { buildWhatsAppLink, defaultMessage } from '../../data/contact';

export function Work() {
  return (
    <Section id="work" title="Selected work">
      <div className="border-b border-rule">
        {projects.map((p) => {
          const cover = p.images[0];
          return (
            <Row key={p.slug} to={p.path}>
              <div className="grid gap-5 sm:grid-cols-3 md:col-span-8">
                <img
                  src={`${cover.src}-640.webp`}
                  width={cover.width}
                  height={cover.height}
                  alt=""
                  loading="lazy"
                  className="aspect-[2/1] w-full rounded-frame bg-paper-2 object-cover object-top sm:col-span-1"
                />
                <div className="sm:col-span-2">
                  <h3 className="font-display text-h3">
                    <span className="box-decoration-clone transition-colors duration-fast group-hover:bg-mark group-hover:text-on-mark group-focus-visible:bg-mark group-focus-visible:text-on-mark">
                      {p.title}
                    </span>
                  </h3>
                  <p className="mt-2 max-w-measure">{p.summary}</p>
                </div>
              </div>
              <Note as="ul" className="md:col-span-4">
                {p.stack.map((s) => (
                  <li key={s}>{s}</li>
                ))}
              </Note>
            </Row>
          );
        })}
      </div>
    </Section>
  );
}

export function Experience() {
  return (
    <Section id="experience" title="Experience">
      <div className="border-b border-rule">
        {experience.map((job) => (
          <Row key={`${job.company}-${job.period}`}>
            <div className="md:col-span-8">
              <h3 className="font-display text-h3">{job.role}</h3>
              <p className="font-display font-medium text-ink-2">{job.company}</p>
              <ul className="mt-4 max-w-measure space-y-3">
                {job.points.map((point) => (
                  <li key={point} className="relative pl-5 before:absolute before:left-0 before:content-['–']">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
            <Note as="ul" className="md:col-span-4">
              <li>{job.period}</li>
              {job.place && <li>{job.place}</li>}
              {job.type && <li>{job.type}</li>}
              {job.focus && (
                <li className="mt-3">
                  {job.focus.map((item) => (
                    <span key={item} className="block">
                      {item}
                    </span>
                  ))}
                </li>
              )}
            </Note>
          </Row>
        ))}
      </div>
    </Section>
  );
}

export function Contact() {
  const { links } = profile;
  return (
    <Section id="contact" title="Get in touch">
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-12">
        <div className="md:col-span-8">
          <p className="font-body text-lead">Email is best. WhatsApp works too.</p>
          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3">
            <Button href={`mailto:${links.email}`}>Send an email</Button>
            <ul className="flex flex-wrap gap-x-6 gap-y-2 font-display font-medium">
              <li>
                <ExternalLink href={buildWhatsAppLink(defaultMessage)}>WhatsApp</ExternalLink>
              </li>
              <li>
                <ExternalLink href={links.linkedin}>LinkedIn</ExternalLink>
              </li>
              <li>
                <ExternalLink href={links.github}>GitHub</ExternalLink>
              </li>
            </ul>
          </div>
        </div>
        <Note className="md:col-span-4">{links.email}</Note>
      </div>
    </Section>
  );
}
